import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import Topbar from "./Topbar";
import { GlobalState } from "../../data/Context";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaBook,
  FaQuestionCircle,
  FaChartLine,
  FaSchool,
  FaTrophy,
  FaUser,
} from "react-icons/fa";

const Sidebar = ({ children }) => {
  const { nav, toggleNav, auth } = useContext(GlobalState);
  const location = useLocation();

  const links = [
    { to: "/", label: "Dashboard", icon: <FaUserGraduate /> },
    { to: "/students", label: "Students", icon: <FaUserGraduate /> },
    // { to: "/teachers", label: "Teachers", icon: <FaChalkboardTeacher /> },
    { to: "/lessons", label: "Lessons", icon: <FaBook /> },
    {
      to: "/questions-portal",
      label: "Questions Portal",
      icon: <FaQuestionCircle />,
    },
    { to: "/performance", label: "Performance", icon: <FaChartLine /> },
    { to: "/classroom", label: "Classroom", icon: <FaSchool /> },
    { to: "/leaderboard", label: "Leaderboard", icon: <FaTrophy /> },
    { to: "/profile", label: "My Profile", icon: <FaUser /> },
  ];

  return (
    <>
      <div>
        <button
          type="button"
          className="inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          onClick={toggleNav}
        >
          <span className="sr-only">Open sidebar</span>
          <svg
            className="w-6 h-6"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule="evenodd"
              fillRule="evenodd"
              d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
            ></path>
          </svg>
        </button>
        <div
          className={`fixed md:hidden top-0 left-0 z-40 w-full h-screen transition-transform bg-black opacity-10 ${
            nav ? "translate-x-0" : "-translate-x-full md:translate-x-0"
          }`}
          onClick={toggleNav}
        ></div>
        {auth?.isAuth && (
          <aside
            className={`fixed top-0 left-0 z-40 w-72 h-screen transition-transform ${
              nav ? "translate-x-0" : "-translate-x-full md:translate-x-0"
            }`}
          >
            <div className="h-full shadow-sm overflow-y-auto bg-white scrollbar-hide">
              <div className=" h-full py-4">
                <div className="px-8 my-4">
                  <img src="/assets/Logo.png" alt="Celma_logo" />
                </div>
                <div className="mb-4 pl-6">
                  <Topbar />
                </div>
                <nav>
                  {links.map(({ to, label, icon }) => (
                    <Link
                      key={to}
                      to={to}
                      className={`block relative py-2.5 px-9 rounded font-sans font-bold text-[18.97px] hover:bg-[#F8F8F8] mb-4 ${
                        location.pathname === to
                          ? "bg-purple-200 text-purple-600 active-link"
                          : "text-gray-600 hover:text-[#6a0dad]"
                      }`}
                    >
                      <span className="absolute left-0 top-0 bottom-0 w-1 bg-purple-600 rounded-tr-lg rounded-br-lg transform scale-0 transition-transform duration-300 origin-left">
                        {location.pathname === to && (
                          <span className="block h-full w-1 bg-purple-600 rounded-tr-lg rounded-br-lg"></span>
                        )}
                      </span>
                      <span className="inline-flex items-center">
                        {icon}
                        <span className="ml-3">{label}</span>
                      </span>
                    </Link>
                  ))}
                </nav>
              </div>
            </div>
          </aside>
        )}

        <div className={`${auth?.isAuth && "sm:ml-72"}`}>{children}</div>
      </div>
    </>
  );
};

export default Sidebar;
